import { render, staticRenderFns } from "./ElForm.vue?vue&type=template&id=6036cc8e"
import script from "./ElForm.vue?vue&type=script&lang=js"
export * from "./ElForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports